<template>
  <bm-text
    v-bind="$attrs"
    :value="value"
    @update:value="emit('update:value', $event)"
  >
    <template v-if="value" #readOnly>
      <a :href="telephoneHref"><bm-icon icon="Phone" />{{ value }}</a>
    </template>
  </bm-text>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface BmTelephoneProps {
  value?: string;
}

interface BmTelephoneEvents {
  (event: "update:value", value: string): void;
}

const props = defineProps<BmTelephoneProps>();
const emit = defineEmits<BmTelephoneEvents>();

const telephoneHref = computed(() => `tel:${props.value}`);
</script>

<style scoped lang="sass">
a
  margin-top: .3em
  display: block

a i.v-icon
  width: 25px
  height: 25px
  margin-right: 0.25em
  margin-left: 0
  transform: rotate(90deg)
</style>
